import React from 'react';
import { Home, School, Building2, MapPin, Users, Shield } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  'home': Home,
  'school': School,
  'building': Building2,
  'map-pin': MapPin
};

export const VibeFeature = () => {
  const feature = features[1];
  
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Visual - appears first on mobile, second on desktop */}
          <div className="relative order-2 lg:order-1">
            <div className="relative z-10">
              <img 
                src="https://images.unsplash.com/photo-1582298538104-fe2e74c27f59"
                alt="Vibe Secure Circle"
                className="rounded-3xl shadow-2xl w-full h-96 object-cover"
              />
              {/* Overlay card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-6 rounded-2xl shadow-xl">
                <div className="flex items-center gap-3 mb-3">
                  <Shield className="h-6 w-6 text-emerald-600" />
                  <span className="font-semibold text-gray-900">Safe Zones</span>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {feature.safeZones.map((zone, index) => {
                    const Icon = iconMap[zone.icon];
                    return (
                      <div key={index} className="flex items-center gap-2 text-sm text-gray-600">
                        <Icon className="h-4 w-4 text-emerald-600" />
                        <span>{zone.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-emerald-200 rounded-full opacity-50 blur-3xl"></div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-green-200 rounded-full opacity-50 blur-3xl"></div>
          </div>

          {/* Content */}
          <div className="space-y-6 order-1 lg:order-2">
            <div className="inline-block">
              <span className="text-emerald-600 font-bold text-sm uppercase tracking-wider bg-emerald-100 px-4 py-2 rounded-full">
                Secure Circle
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              {feature.title}
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {feature.description}
            </p>

            {/* Highlights */}
            <div className="space-y-4 pt-4">
              {feature.highlights.map((highlight, index) => {
                const icons = [Users, MapPin, Shield];
                const Icon = icons[index];
                return (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon className="h-5 w-5 text-emerald-600" />
                    </div>
                    <span className="text-gray-700 text-lg font-medium">{highlight}</span>
                  </div>
                );
              })}
            </div>

            {/* Safe Zone Note */}
            <div className="mt-8 p-6 bg-emerald-50 rounded-2xl border border-emerald-100">
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold text-emerald-900">Peace of mind, not surveillance.</span> Stay connected without constant calling. Your Vibe circle keeps you informed when it matters.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
